/**
 * Centralized configuration for environment variables.
 */
export const environment = {
  // The base URL of your Magnolia instance
  MAGNOLIA_BASE_URL: process.env.REACT_APP_MAGNOLIA_BASE_URL || 'http://localhost:8080',

  // The base path for your SPA in the Magnolia site structure (e.g., '/home')
  APP_BASE: process.env.REACT_APP_MGNL_APP_BASE || '/home',
};
